// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 32px;
  min-height: calc(100vh - 100px);
  align-items: start;
  padding: 0 40px;
}

.admin-sidebar {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px var(--shadow);
  height: fit-content;
  align-self: start;
  position: sticky;
  top: 112px;
  max-height: calc(100vh - 124px);
  overflow-y: auto;
}

.admin-sidebar h2 {
  font-size: 24px;
  margin-bottom: 24px;
  color: var(--dark);
}

.admin-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-nav-link {
  padding: 12px 16px;
  border-radius: 8px;
  color: var(--text-dark);
  font-weight: 500;
  border: 1px solid var(--border);
  transition: all 0.3s ease;
}

.admin-nav-link:hover {
  background-color: #f5f5f5;
  color: var(--dark);
}

.admin-nav-link.active {
  background-color: var(--dark);
  border-color: var(--dark);
  color: white;
}

.admin-content {
  min-width: 0;
}

@media (max-width: 768px) {
  .admin-dashboard {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }

  .admin-sidebar {
    position: static;
    max-height: none;
    overflow: visible;
  }

  .admin-nav {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".admin-dashboard {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  gap: 32px;\n  min-height: calc(100vh - 100px);\n  align-items: start;\n  padding: 0 40px;\n}\n\n.admin-sidebar {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px var(--shadow);\n  height: fit-content;\n  align-self: start;\n  position: sticky;\n  top: 112px;\n  max-height: calc(100vh - 124px);\n  overflow-y: auto;\n}\n\n.admin-sidebar h2 {\n  font-size: 24px;\n  margin-bottom: 24px;\n  color: var(--dark);\n}\n\n.admin-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-nav-link {\n  padding: 12px 16px;\n  border-radius: 8px;\n  color: var(--text-dark);\n  font-weight: 500;\n  border: 1px solid var(--border);\n  transition: all 0.3s ease;\n}\n\n.admin-nav-link:hover {\n  background-color: #f5f5f5;\n  color: var(--dark);\n}\n\n.admin-nav-link.active {\n  background-color: var(--dark);\n  border-color: var(--dark);\n  color: white;\n}\n\n.admin-content {\n  min-width: 0;\n}\n\n@media (max-width: 768px) {\n  .admin-dashboard {\n    grid-template-columns: 1fr;\n    padding: 0 20px;\n  }\n\n  .admin-sidebar {\n    position: static;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .admin-nav {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
